import classNames from "components/ui/classNames";
import { RadioGroup, RadioGroupItem } from "components/ui/RadioGroup";

export enum ChartPeriodId {
  P1M = "1M",
  P3M = "3M",
  P6M = "6M",
  P1Y = "1Y",
  YTD = "YTD",
  P5Y = "5Y",
  P10Y = "10Y",
  AllTime = "ALL_TIME",
}

type ChartPeriod = {
  period: ChartPeriodId;
  label: string;
  tooltipContent: string;
  disabled?: boolean;
  from: Date;
  to?: Date;
};
interface ChartPeriodSelectorProps {
  periods: ChartPeriod[];
  value: ChartPeriodId;
  onChange: (periodId: ChartPeriodId, startDate: Date, endDate: Date) => void;
}
export default function ChartPeriodSelector({ periods, value, onChange }: ChartPeriodSelectorProps) {
  return (
    <RadioGroup
      loop={false}
      className={classNames(
        "col-span-3 row-start-3",
        "grid w-full grid-cols-4 items-center justify-between rounded-2xl border border-slate-200 bg-slate-50/60 p-1",
        "sm:flex sm:w-auto sm:max-w-sm sm:justify-normal sm:space-x-2",
        "dark:border-slate-950 dark:bg-slate-700 dark:text-slate-300",
      )}
      orientation="horizontal"
      value={value}
      onValueChange={(value) => {
        const period = periods.find((node) => node.period === value);
        if (period) {
          onChange(value as ChartPeriodId, period.from, new Date());
        }
      }}
    >
      {periods.map(({ period, disabled, tooltipContent, label }) => {
        return (
          <RadioGroupItem
            key={period}
            value={period}
            disabled={disabled}
            title={tooltipContent}
            className={classNames(
              "h-9 w-full items-center justify-center rounded-xl p-1 text-center sm:w-10",
              "border border-transparent text-sm font-medium tracking-wide text-slate-500",
              "data-[state=checked]:bg-violet-50 data-[state=checked]:font-bold data-[state=checked]:text-violet-600",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-100 focus-visible:ring-offset-1 focus-visible:ring-offset-gray-300",
              "data-[state=checked]:focus-visible:rounded-xl data-[state=checked]:focus-visible:bg-gray-50 data-[state=checked]:focus-visible:text-gray-600",
            )}
          >
            {label}
          </RadioGroupItem>
        );
      })}
    </RadioGroup>
  );
}
